import type {Users} from '@manaboo/db/types';
import {getCookie, setCookie} from '@manaboo/utils/cookies';

export class Referrals {
	readonly REFERRAL_VALUE = 5;
	readonly COOKIE_NAME = 'manaboo_referral_id';
	readonly COOKIE_EXPIRY_DAYS = 30;

	public setReferralCookie(referralId: Users['referral_token']): boolean {
		try {
			if (!referralId) {
				return false;
			}

			const existingReferral = this.getReferralFromCookie();

			if (existingReferral === referralId) {
				setCookie(this.COOKIE_NAME, String(referralId), this.COOKIE_EXPIRY_DAYS);

				return true;
			}

			if (existingReferral !== null) {
				return false;
			}

			setCookie(this.COOKIE_NAME, String(referralId), this.COOKIE_EXPIRY_DAYS);

			return true;
		} catch (error) {
			console.error('Error setting referral cookie:', error);

			return false;
		}
	}

	public getReferralFromCookie(): Users['referral_token'] | null {
		try {
			const referralCookie = getCookie(this.COOKIE_NAME);

			return referralCookie ? referralCookie : null;
		} catch (error) {
			console.error('Error getting referral cookie:', error);

			return null;
		}
	}
}
